import { api } from "services";

export const getAllActiveAndIncludeRoleByIds = async (ids = []) => {
	try {
		const response = await api.researchRoles.findAll({
			size: 100,
			activeOnly: false,
		});

		const items = response?.content
			.filter(item => item.active || ids.includes(item.researchRoleId))
			.sort(item => item.position - item.position);

		return {
			items,
			totalItems: items.length,
		};
	} catch {
		return {
			items: [],
			totalItems: 0,
		};
	}
};
